module.exports = __webpack_public_path__ + "img/item-info-icon7.155d4191.svg";